import { useQuery } from "@tanstack/react-query";

import { getCarbonProgramContractByProgramId } from "services";

import { GET_PROGRAM_CONTRACT } from "consts";

import { ProgramContract } from "models";

export const useGetProgramContractByProgramId = ({ programId }: { programId: string }) =>
  useQuery<ProgramContract>({
    queryKey: [GET_PROGRAM_CONTRACT, programId],
    queryFn: () => getCarbonProgramContractByProgramId(programId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
